import React from "react";
import {SiteData} from "../../Constants/siteData";
import {PageWrapper} from "../../Components/PageWrapper/PageWrapper";
import PageHeader from "../../Components/common/PageHeader";
import ServicePageTemplate from "../../Containers/ServiceContainers/ServicePageTemplate";
import {SEO} from "../../Components/SEO/SEO";

export default function TreeRemoval() {
    return (
        <PageWrapper>
            <SEO title={SiteData.treeRemoval.metaData.title} description={SiteData.treeRemoval.metaData.description}/>
            <PageHeader header={SiteData.treeRemoval.h1} subtitle={SiteData.treeRemoval.subtitle}/>
            <ServicePageTemplate body={SiteData.treeRemoval.body}/>
        </PageWrapper>
    )
}
